import { render, staticRenderFns } from "./orderDiscountTooltip.vue?vue&type=template&id=726a6406&scoped=true"
import script from "./orderDiscountTooltip.vue?vue&type=script&lang=js"
export * from "./orderDiscountTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726a6406",
  null
  
)

export default component.exports